/*
 * DataTableCell
 * @module components
 * @flow
 */

import React from 'react';
import styled from 'styled-components/macro';
import { Tooltip } from '~/components';

// $FlowIssue
export type CellValueProps = {
  value: string,
};

const Ellipsis = styled.span`
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

/**
 * DataTableCell React-component
 * @memberof components
 * @param {Object} props - properties
 * @param {string} [props.value] - cell value
 * @example <caption>Simple usage</caption>
 * <DataTableCell value="123" />
 * @returns {React.Node<*>} React-component
 */
export const DataTableCell = ({ value }: CellValueProps) => (
  <Tooltip placement="left" overlay={value}>
    <Ellipsis>{value}</Ellipsis>
  </Tooltip>
);

DataTableCell.defaultProps = {
  value: '',
};
